"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EN_STAY_SERVICE_TITLE_KR_REVERSE = exports.EN_STAY_SERVICE_TITLE_KR = exports.EN_STAY_SERVICE_TYPE = exports.EN_STAY_SERVICE_CODE = void 0;
/** 객실사용 유형 */
var EN_STAY_SERVICE_CODE;
(function (EN_STAY_SERVICE_CODE) {
    /** 대실 */
    EN_STAY_SERVICE_CODE[EN_STAY_SERVICE_CODE["DAY_USE"] = 1] = "DAY_USE";
    /** 숙박 */
    EN_STAY_SERVICE_CODE[EN_STAY_SERVICE_CODE["STAY"] = 2] = "STAY";
    /** 연박 */
    EN_STAY_SERVICE_CODE[EN_STAY_SERVICE_CODE["LONG_TERM"] = 3] = "LONG_TERM";
})(EN_STAY_SERVICE_CODE = exports.EN_STAY_SERVICE_CODE || (exports.EN_STAY_SERVICE_CODE = {}));
/** 객실사용 유형 문자열 */
var EN_STAY_SERVICE_TYPE;
(function (EN_STAY_SERVICE_TYPE) {
    /** 대실 */
    EN_STAY_SERVICE_TYPE["DAY_USE"] = "DAY_USE";
    /** 숙박 */
    EN_STAY_SERVICE_TYPE["STAY"] = "STAY";
    /** 연박 */
    EN_STAY_SERVICE_TYPE["LONG_TERM"] = "LONG_TERM";
})(EN_STAY_SERVICE_TYPE = exports.EN_STAY_SERVICE_TYPE || (exports.EN_STAY_SERVICE_TYPE = {}));
/** 객실사용 유형 문자열 */
var EN_STAY_SERVICE_TITLE_KR;
(function (EN_STAY_SERVICE_TITLE_KR) {
    /** 대실 */
    EN_STAY_SERVICE_TITLE_KR["DAY_USE"] = "\uB300\uC2E4";
    /** 숙박 */
    EN_STAY_SERVICE_TITLE_KR["STAY"] = "\uC219\uBC15";
    /** 연박 */
    EN_STAY_SERVICE_TITLE_KR["LONG_TERM"] = "\uC5F0\uBC15";
})(EN_STAY_SERVICE_TITLE_KR = exports.EN_STAY_SERVICE_TITLE_KR || (exports.EN_STAY_SERVICE_TITLE_KR = {}));
/** 객실사용 유형 문자열 */
var EN_STAY_SERVICE_TITLE_KR_REVERSE;
(function (EN_STAY_SERVICE_TITLE_KR_REVERSE) {
    /** 대실 */
    EN_STAY_SERVICE_TITLE_KR_REVERSE["\uB300\uC2E4"] = "DAY_USE";
    /** 숙박 */
    EN_STAY_SERVICE_TITLE_KR_REVERSE["\uC219\uBC15"] = "STAY";
    /** 연박 */
    EN_STAY_SERVICE_TITLE_KR_REVERSE["\uC5F0\uBC15"] = "LONG_TERM";
})(EN_STAY_SERVICE_TITLE_KR_REVERSE = exports.EN_STAY_SERVICE_TITLE_KR_REVERSE || (exports.EN_STAY_SERVICE_TITLE_KR_REVERSE = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRU5fU1RBWV9TRVJWSUNFX1RZUEUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi9zcmMvc2FwcG9yby9jb25zdGFudC9lbnVtL3BsYWNlL0VOX1NUQVlfU0VSVklDRV9UWVBFLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLGNBQWM7QUFDZCxJQUFZLG9CQU9YO0FBUEQsV0FBWSxvQkFBb0I7SUFDOUIsU0FBUztJQUNULHFFQUFXLENBQUE7SUFDWCxTQUFTO0lBQ1QsK0RBQUksQ0FBQTtJQUNKLFNBQVM7SUFDVCx5RUFBUyxDQUFBO0FBQ1gsQ0FBQyxFQVBXLG9CQUFvQixHQUFwQiw0QkFBb0IsS0FBcEIsNEJBQW9CLFFBTy9CO0FBRUQsa0JBQWtCO0FBQ2xCLElBQVksb0JBT1g7QUFQRCxXQUFZLG9CQUFvQjtJQUM5QixTQUFTO0lBQ1QsMkNBQW1CLENBQUE7SUFDbkIsU0FBUztJQUNULHFDQUFhLENBQUE7SUFDYixTQUFTO0lBQ1QsK0NBQXVCLENBQUE7QUFDekIsQ0FBQyxFQVBXLG9CQUFvQixHQUFwQiw0QkFBb0IsS0FBcEIsNEJBQW9CLFFBTy9CO0FBRUQsa0JBQWtCO0FBQ2xCLElBQVksd0JBT1g7QUFQRCxXQUFZLHdCQUF3QjtJQUNsQyxTQUFTO0lBQ1Qsb0RBQWMsQ0FBQTtJQUNkLFNBQVM7SUFDVCxpREFBVyxDQUFBO0lBQ1gsU0FBUztJQUNULHNEQUFnQixDQUFBO0FBQ2xCLENBQUMsRUFQVyx3QkFBd0IsR0FBeEIsZ0NBQXdCLEtBQXhCLGdDQUF3QixRQU9uQztBQUVELGtCQUFrQjtBQUNsQixJQUFZLGdDQU9YO0FBUEQsV0FBWSxnQ0FBZ0M7SUFDMUMsU0FBUztJQUNULDREQUFnQixDQUFBO0lBQ2hCLFNBQVM7SUFDVCx5REFBYSxDQUFBO0lBQ2IsU0FBUztJQUNULDhEQUFrQixDQUFBO0FBQ3BCLENBQUMsRUFQVyxnQ0FBZ0MsR0FBaEMsd0NBQWdDLEtBQWhDLHdDQUFnQyxRQU8zQyJ9